import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import PeriodosAcademicosView from './PeriodosAcademicosView';
import * as ROUTES from '../../../router/Routes';

const PeriodosAcademicosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.periodosAcademicos}
      routes={[ROUTES.controlEstudios]}
    >
      <PeriodosAcademicosView />
    </ContainerTemplate>
  );
};

export default PeriodosAcademicosModule;
